import { SeenThingsPresenter } from '@Components/Modals/SeenThings/SeenThingsPresenter';
import type { FloorMapPresenter } from '@Map/FloorMap/FloorMapPresenter';
import { ObservableProp, useClassStore } from '@Utils/useClassStore';
import { inject, injectable, postConstruct } from 'inversify';
import { computed } from 'mobx';

import container from '~ioc/ioc';

@injectable()
export class HamburgerButtonPresenter {
  private _floorMapPresenter = new ObservableProp<
    FloorMapPresenter | undefined
  >(undefined);
  @inject(SeenThingsPresenter)
  private _seenThingsPresenter!: SeenThingsPresenter;

  @postConstruct() postConstruct() {
    this._seenThingsPresenter.bindHamburgerMenu(this); // Solves circular dependency injection
  }

  isOpen = new ObservableProp(false);

  @computed get showHamburger(): boolean {
    return Boolean(!this._floorMapPresenter.value?.extendedMapVisible);
  }

  setFloorMapPresenter = (presenter: FloorMapPresenter) => {
    this._floorMapPresenter.set(presenter);
  };

  onPress = () => {
    this._seenThingsPresenter.hide();
    this.isOpen.set(!this.isOpen.value);
  };
}

export const useHamburgerButtonPresenter = () =>
  useClassStore<HamburgerButtonPresenter>(
    container.get(HamburgerButtonPresenter)
  );
